import React from 'react';
import { useSelector } from 'react-redux';
import type { FunctionComponent } from 'react';
import { getSectionTitle } from '../../../store/contentSlice';

const MyCards: FunctionComponent = () => {
  const { cardsTitle }: any = useSelector(getSectionTitle);
  return (
    <div className="my-cards" data-testid="txt-my-cards">
      {cardsTitle}
    </div>
  );
};

export default MyCards;
